import { Button, Modal } from 'antd';
import { useContext, useEffect, useState } from 'react';
import CTX from '../../../lib/AssignmentsContext';
import TasksList from '../TasksList';
import StudentsPicker from '../StudentsPicker';
import DetailsForm from '../DetailsForm';
import ClassPicker from '../ClassPicker';
const SingleAssignmentWizard = () => {
  const {
    data,
    actions,
    status
  } = useContext(CTX);
  const [listConfirmed, setListConfirmed] = useState(null);
  const {
    submit,
    reset
  } = actions;
  const assignmentsNumber = data.assignments.length;
  const tasksNumber = data.assignments.map(a => a.data.tasks.length).reduce((s, v) => s + v, 0);
  useEffect(() => {
    assignmentsNumber > 0 && status.listPrepared && listConfirmed === null && setListConfirmed(tasksNumber === 1);
  }, [status.listPrepared, listConfirmed, setListConfirmed, assignmentsNumber, tasksNumber]);
  const almostReady = assignmentsNumber > 0 && data.assignments.every(({
    data
  }) => Object.values(data).every(Boolean));
  const ready = almostReady && data.klass && data.studentIDs.length > 0;
  const shouldSubmit = (() => {
    const {
      listPrepared,
      ...rest
    } = status;
    return listPrepared && ready && !Object.values(rest).some(Boolean);
  })();
  useEffect(() => {
    if (shouldSubmit) {
      setListConfirmed(null);
      data.assignments[0].actions.submit(data.klass.id, data.studentIDs);
    }
  }, [shouldSubmit]);
  const tasksCount = data.assignments.map(({
    data
  }) => data.tasks.length).reduce((acc, val) => acc + val, 0);
  const modal = <Modal title={<>
					New Assignment: {data.assignments[0]?.data.label} {' '}
					<span className="helper-text">({tasksCount} activities)</span>
				</>} open closable destroyOnClose footer={null} width={800 + 100 + 24 * 2} onCancel={() => {
    setListConfirmed(null);
    reset();
  }}>
		{!listConfirmed ? <>
					<TasksList assignmentIndex={0} editable />
					<div style={{
        textAlign: "right"
      }}>
						<Button type="primary" onClick={() => setListConfirmed(true)} disabled={tasksNumber === 0}>Next</Button>
					</div>
				</> : !(data.klass && data.klass.students?.length > 0) ? <ClassPicker /> : data.studentIDs.length === 0 ? <StudentsPicker onCancel={() => {
      data.klass = null;
    }} /> : <DetailsForm onCancel={() => {
      data.studentIDs = [];
    }} />}
		</Modal>;
  return <>
			{status.listPrepared && modal}
		</>;
};
export default SingleAssignmentWizard;